export const RESET_SESSION = 'vehicles/session/reset';

export const sessionActions = {
  reset: () => ({ type: RESET_SESSION as typeof RESET_SESSION })
};
